import React, { useEffect, useState } from "react";
import ClaimCard from "./ClaimCard";
import "./Claims.css";
import axiosInstance from "../../axiosInstance";
import LoadingComponent from "../../components/loading/Loading";
import Pagination from "../../components/pagination/Pagination";
import TitleComponent from "../../components/title/Title";

interface OrderItem {
  id: string;
  name: string;
  quantity: number;
  price: number;
  line_total: number;
  description: string;
  image?: string; // Add image if available
}

interface ShippingDetails {
  name: string;
  address: string;
  phone: string;
}

interface OrderStatus {
  status: string;
  date: string;
}

interface Order {
  id: string;
  amount: number;
  createdAt: string;
  order_items: OrderItem[];
  customer: {
    full_name: string;
    phone_number: string;
  };
  vendor: {
    name: string;
    address?: string;
    phone?: string;
  };
  status: string;
}

const ORDERS_PER_PAGE = 5;

const Claims = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  // Pagination logic
  const totalPages = Math.ceil(orders.length / ORDERS_PER_PAGE);
  const paginatedOrders = orders.slice(
    (currentPage - 1) * ORDERS_PER_PAGE,
    currentPage * ORDERS_PER_PAGE
  );

  useEffect(() => {
    axiosInstance
      .get("/orders")
      .then((res) => {
        const sortedOrders = (res.data.data || []).sort(
          (a: Order, b: Order) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        setOrders(sortedOrders);
      })
      .catch((err) => {
        console.error("Failed to fetch orders:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  // Transform API order to ClaimCard props
  const mapOrderToCard = (order: Order) => {
    const formatDate = (dateStr?: string) =>
      dateStr
        ? new Date(dateStr).toLocaleDateString(undefined, {
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        : "pending";

    const placedDate = formatDate(order.createdAt);
    const readyForPickupDate =
      order.status === "ready_for_pickup" || order.status === "complete"
        ? placedDate
        : "pending";
    const completeDate = order.status === "complete" ? placedDate : "pending";
    const description =
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."; // Placeholder

    return {
      orderId: order.id,
      amount: order.amount,
      orderDate: placedDate,
      items: order.order_items.length,
      shippingDetails: {
        name: order.customer.full_name,
        address: order.vendor.name,
        phone: order.customer.phone_number,
      },
      orderStatus: [
        { status: "Order placed", date: placedDate },
        // { status: "Ready for Pickup", date: readyForPickupDate },
        { status: "Claim Status", date: completeDate },
        { status: "Description", date: description },
      ],
      orderItems: order.order_items.map((item) => ({
        name: item.name,
        price: item.price,
        quantity: item.quantity,
        image: item.image,
      })),
    };
  };

 

  return (
    <div className="claim-orders">
      <TitleComponent title="Claim Requests" />


      {
        loading ? (<div style={{textAlign:"center"}}> Loading... </div>) : null
      }
      {orders.length === 0 && !loading && <div>No orders found.</div>}
      {paginatedOrders.map((order) => (
        <ClaimCard key={order.id} {...mapOrderToCard(order)} />
      ))}
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
    </div>
  );
};

export default Claims;
